import React from "react";

export default function NotFoundPage() {
  return <div style={{ color: "red", padding: 20 }}><h2>404 - Page Not Found</h2></div>;
}
